import { useLocation } from "react-router-dom";

const useURLSearchParams = (): URLSearchParams => {
	return new URLSearchParams(useLocation().search);
};

export default useURLSearchParams;
